import React from 'react'
import { RetentionResource, SessionRetention } from '../../../models/RetentionPolicy'
import { Col, Row } from 'react-bootstrap'
const EMPTY_FIELD_MESSAGE = '-'

export const RetentionPolicySessionResourceBody: React.FC<{ retentionResource: RetentionResource }> = ({ retentionResource }) => {
  const resource = retentionResource as SessionRetention
  return (
    <>
      <Row>
        <Col>
          <div>Meeting kind</div>
          <div aria-label='Resource type'>{resource.config?.kind || EMPTY_FIELD_MESSAGE}</div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>Meeting source</div>
          <div aria-label='Resource type'>{resource.config?.source || EMPTY_FIELD_MESSAGE}</div>
        </Col>
      </Row>
    </>
  )
}
